/**
 * Five Elephant — quantity +/- on all product forms.
 * Event delegation so it works even if theme quantity-counter
 * fails, or forms are re-rendered by ReCharge / BSS.
 */
(function () {
  'use strict';

  var ROOT_SEL =
    '[data-fe-quantity], quantity-counter.quantity-selector, .custom-quantity-selector, .quantity-selector, .js-qty';
  var BTN_SEL =
    '[data-fe-qty], .quantity__plus, .quantity__minus, .js-qty__adjust--plus, .js-qty__adjust--minus, .fe-quantity__btn';
  var INPUT_SEL = 'input[name="quantity"], input.quantity__input, input.fe-quantity__input, input.js-qty__num';

  function isIncrease(el) {
    if (!el) return false;
    if (el.getAttribute('data-fe-qty') === 'increase') return true;
    if (el.getAttribute('name') === 'increase') return true;
    if (el.classList.contains('quantity__plus')) return true;
    if (el.classList.contains('js-qty__adjust--plus')) return true;
    return false;
  }

  function isDecrease(el) {
    if (!el) return false;
    if (el.getAttribute('data-fe-qty') === 'decrease') return true;
    if (el.getAttribute('name') === 'decrease') return true;
    if (el.classList.contains('quantity__minus')) return true;
    if (el.classList.contains('js-qty__adjust--minus')) return true;
    return false;
  }

  function findRoot(from) {
    return from && from.closest ? from.closest(ROOT_SEL) : null;
  }

  function findInput(root) {
    if (!root) return null;
    return root.querySelector(INPUT_SEL);
  }

  function readMin(input) {
    var min = parseInt(input.getAttribute('min'), 10);
    return isNaN(min) ? 1 : min;
  }

  function readMax(input) {
    var max = parseInt(input.getAttribute('max'), 10);
    return isNaN(max) ? 9999 : max;
  }

  function setQuantity(input, next) {
    var min = readMin(input);
    var max = readMax(input);
    var value = Math.max(min, Math.min(max, next));
    var prev = String(input.value);
    var nextStr = String(value);
    if (prev === nextStr) return;
    input.value = nextStr;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function onActivate(e) {
    var btn = e.target && e.target.closest ? e.target.closest(BTN_SEL) : null;
    if (!btn) return;

    var root = findRoot(btn);
    var input = findInput(root);
    if (!input) return;

    e.preventDefault();
    e.stopPropagation();

    var current = parseInt(input.value, 10);
    if (isNaN(current) || current < 1) current = 1;

    if (isIncrease(btn)) {
      setQuantity(input, current + 1);
      return;
    }
    if (isDecrease(btn)) {
      setQuantity(input, current - 1);
    }
  }

  function onKey(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target && e.target.closest ? e.target.closest(BTN_SEL) : null;
    if (!btn) return;
    e.preventDefault();
    onActivate(e);
  }

  document.addEventListener('click', onActivate, true);
  document.addEventListener('keydown', onKey, true);
})();
